import * as React from 'react';
import { TeamMembersNode } from './Types';
import TableHeader from './TableHeader';
import TeamMembersDetails from './TeamMembersDetails';
import { observer } from 'mobx-react';
import { fromEmpty } from 'maybeasy';

interface Props {
  node: TeamMembersNode;
}

const TeamMembers: React.FC<Props> = ({ node }) => (
  <>
    {fromEmpty(node.teamMembers.payload).cata({
      Just: () => (
        <table className="p3-table">
          <TableHeader />
          <TeamMembersDetails node={node} />
        </table>
      ),
      Nothing: () => <></>,
    })}
  </>
);

export default observer(TeamMembers);
